import "../../src/assets/fonts/icomoon/style.css";

import React from "react";
import { createRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import clientComponent from "../config/clientComponents";
import windowSize from "../utils/windowSize";
import Map from "./Map";
import OverlayHeader from "./OverlayHeader";
import Sidebar from "./Sidebar";
//import filterBehaviour from "../utils/filterBehaviour";
import { dataCheck } from "../utils/dataCheck";

const GlanumLeaflet = ({ data }) => {
  const { t, i18n } = useTranslation();

  //--- Filter the entities that doesn't have long/lat data
  let filteredData = [];
  let displayErrors = document.getElementById("root").dataset.errors;
  //let displayErrors = true;

  const verifiedEntities = dataCheck(data, displayErrors);

  //--- Get pre-filter to apply on page loading if needed
  filteredData = verifiedEntities;
  let dataPreFilter = document.getElementById("root").dataset.filter;
  if (dataPreFilter) {
    dataPreFilter = JSON.parse(dataPreFilter);
  }

  //--- Get filters and pre-filters keys
  let filtersKeys = [];
  if (data.filters) {
    filtersKeys = Object.keys(data.filters);
  }
  let preselectedFiltersKeys = [];
  if (dataPreFilter) {
    preselectedFiltersKeys = Object.keys(dataPreFilter);
  }

  const [filtersState, setFiltersState] = useState({});
  const [selectedInstitution, setSelectedInstitution] = useState();
  const [filteredEntities, setFilteredEntities] = useState(filteredData);
  const [searchState, setSearchState] = useState("");
  const [filterScreen, setFilterScreen] = useState(false);
  const [mapScreen, setMapScreen] = useState(false);
  const [scrollbarRef, setScrollbarRef] = useState({});
  const [sizeState, setSizeState] = useState(() => {
    return window.innerWidth;
  });
  const [showFiltersFrom, setShowFiltersFrom] = useState(null);
  const [userCurrentPosition, setUserCurrentPosition] = useState(null);
  const [geoSearch, setGeoSearch] = useState(null);
  const [selectedGeoAdress, setSelectedGeoAdress] = useState(null);
  const [mapRef, setMapRef] = useState(null);

  //--- Institution item refs to allow scroll
  const lineRefs = useRef([]);
  lineRefs.current = data.entities.map(
    (_, i) => lineRefs.current[i] ?? createRef()
  );

  const customMarkerRefs = useRef([]);
  customMarkerRefs.current = data.entities.map(
    (_, i) => customMarkerRefs.current[i] ?? createRef()
  );

  const popupRefs = useRef([]);
  popupRefs.current = data.entities.map(
    (_, i) => popupRefs.current[i] ?? createRef()
  );

  // const mapRef = useRef(null);

  //--- Initialisation de l'objets Filtres
  useEffect(() => {
    windowSize(sizeState, setSizeState);
    for (const filterKey of filtersKeys) {
      setFiltersState((prevState) => ({
        ...prevState,
        [filterKey]: [],
      }));
    }

    //--- Set up the filter state with the pre-filter
    if (dataPreFilter) {
      for (const preselectedFilterKey of preselectedFiltersKeys) {
        setFiltersState((prevState) => ({
          ...prevState,
          [preselectedFilterKey]: dataPreFilter[preselectedFilterKey],
        }));
      }
    }
  }, []);

  //--- Test if there's is a marker to display at page loading
  let displayMap = true;
  useEffect(() => {
    if (filteredEntities.length > 0) {
      displayMap = true;
    } else {
      displayMap = false;
    }
  }, []);

  //--- Dynamic Import
  const InstitutionInfos = clientComponent["InstitutionInfos"];
  const filterBehaviour = clientComponent["filterBehaviour"];
  const GenericFilter = clientComponent["GenericFilter"];
  const MapHeader = clientComponent["MapHeader"];

  //--- Gestion du comportement des filtres - ajouter l'import dynamique selon le client
  useEffect(() => {
    filterBehaviour(
      filteredData,
      filtersState,
      filtersKeys,
      setFilteredEntities,
      searchState,
      mapRef,
      selectedGeoAdress
    );
  }, [filtersState, searchState, selectedGeoAdress]);

  //--- Trigered by mobile button,
  const closeMapScreen = () => {
    document.body.classList.remove("no-scroll");
    setMapScreen(false);
    setSelectedInstitution(null);
  };

  // --- Reset selected institution on research input
  useEffect(() => {
    setSelectedInstitution(null);
  }, [searchState]);

  return (
    <>
      {displayMap && (
        <div className="glanum-leaflet__wrapper">
          {process.env.REACT_APP_MAPHEADER === "true" && (
            <MapHeader
              searchState={searchState}
              setSearchState={setSearchState}
              setFilterScreen={setFilterScreen}
              setShowFiltersFrom={setShowFiltersFrom}
              filtersKeys={filtersKeys}
              filtersState={filtersState}
              userCurrentPosition={userCurrentPosition}
              setUserCurrentPosition={setUserCurrentPosition}
              setGeoSearch={setGeoSearch}
              geoSearch={geoSearch}
              setSelectedGeoAdress={setSelectedGeoAdress}
            />
          )}
          <div className="glanum-leaflet__content">
            {process.env.REACT_APP_SIDEBAR !== "none" && (
              <div
                className={`sidebar ${
                  process.env.REACT_APP_SIDEBAR === "right"
                    ? "sidebar--right"
                    : ""
                }`}
              >
                <Sidebar
                  data={data}
                  filteredEntities={filteredEntities}
                  setFilteredEntities={setFilteredEntities}
                  selectedInstitution={selectedInstitution}
                  setSelectedInstitution={setSelectedInstitution}
                  filtersState={filtersState}
                  setFiltersState={setFiltersState}
                  filtersKeys={filtersKeys}
                  searchState={searchState}
                  setSearchState={setSearchState}
                  filterScreen={filterScreen}
                  setFilterScreen={setFilterScreen}
                  mapScreen={mapScreen}
                  setMapScreen={setMapScreen}
                  setScrollbarRef={setScrollbarRef}
                  lineRefs={lineRefs}
                  showFiltersFrom={showFiltersFrom}
                  setShowFiltersFrom={setShowFiltersFrom}
                />
              </div>
            )}
            <div
              className={`map__wrapper ${
                mapScreen === true ? "active" : ""
              } flex-grow-1`}
            >
              <OverlayHeader
                title={data.filterSectionTitle}
                setMapScreen={setMapScreen}
                setFilterScreen={setFilterScreen}
                setSelectedInstitution={setSelectedInstitution}
                filtersKeys={filtersKeys}
                filtersState={filtersState}
                setShowFiltersFrom={setShowFiltersFrom}
              />
              <Map
                data={filteredEntities}
                selectedInstitution={selectedInstitution}
                setSelectedInstitution={setSelectedInstitution}
                client={process.env.REACT_APP_CLIENT}
                filtersKeys={filtersKeys}
                filters={data.filters}
                scrollbarRef={scrollbarRef}
                lineRefs={lineRefs}
                customMarkerRefs={customMarkerRefs}
                popupRefs={popupRefs}
                mapRef={mapRef}
                setMapRef={setMapRef}
                sizeState={sizeState}
                userCurrentPosition={userCurrentPosition}
                selectedGeoAdress={selectedGeoAdress}
                setFilteredEntities={setFilteredEntities}
              />
              {mapScreen && (
                <button
                  className={`map-to-list__btn ${
                    selectedInstitution &&
                    process.env.REACT_APP_INSTITUTIONLAYER === "true"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => closeMapScreen()}
                >
                  {t("displayList")}
                </button>
              )}
              {selectedInstitution &&
                process.env.REACT_APP_INSTITUTIONLAYER === "true" && (
                  <InstitutionInfos
                    selectedInstitution={selectedInstitution}
                    setSelectedInstitution={setSelectedInstitution}
                    filters={data.filters}
                  />
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default GlanumLeaflet;
